<div class="alerts">
    <h4>Alerts</h4>
    <div class="filters">
        <label>
            <input type="checkbox" [(ngModel)]="showOpportunities" (change)="filterAlerts()"> Opps ({{ opportunityCount }})
        </label>
        <label>
            <input type="checkbox" [(ngModel)]="showLeases" (change)="filterAlerts()"> Leases ({{ leaseCount }})
        </label>
    </div>
    <ul class="grid-list">
        <li *ngFor="let alert of filteredAlerts" (click)="onAlertClick(alert)">
            <h5>{{ alert.message }}</h5>
            <br>
            <h6 *ngIf="user.user?.admin===1">Assignee: {{alert.user.first_name}} {{alert.user.last_name}}</h6>
            <p>{{ alert.created_at }} <ion-icon *ngIf="alert.type=='email'" name="mail-open"></ion-icon><ion-icon *ngIf="alert.type=='message'" name="chatbubble"></ion-icon></p>
            <div class="circle" *ngIf="!alert?.read"></div>
        </li>
    </ul>
</div>
<div class="button" (click)="onViewAllClick()">
    VIEW ALL ALERTS
</div>